<template>
  <div
    v-if="data && $login.can('accounts.view')"
    class="accounts-view"
  >
    <page-header :header="data.name">
      <button
        v-if="canEdit && $login.can('analytics.network')"
        @click="generateExcel()"
        class="d-none d-lg-flex mr-2 btn btn-primary"
      >
        Export to Excel
      </button>
      <dropdown
        v-if="$login.can('accounts.update')"
        trigger="click"
        alignment="right"
        class="plain no-chev"
      >
        <button class="btn btn-outline-primary btn--more"
        slot="trigger">
          <icon icon="more-vertical" />
        </button>
        <dropdown-option
          v-if="canEdit && $login.can('analytics.network')"
          class="d-lg-none"
          @click.native="generateExcel()"
          href="javascript:;"
        >
          <icon
            icon="folder"
            class="mr-2"
          /> Export to Excel
        </dropdown-option>

        <dropdown-option
            v-if="canEdit && $login.can('analytics.network')"
            class=""
            @click.native="generateExcel('this_365_days')"
          >
            <icon
              icon="folder"
              class="mr-2"
            /> Export last 365 days to Excel
        </dropdown-option>

        <dropdown-option
          v-if="$login.can('accounts.update') && $login.can('users.create')"
          class="page-header-dropdown-item"
          @click.native="addUser"
          href="javascript:;"
        >
          <icon
            icon="user"
            class="mr-2"
          /> Create user
        </dropdown-option>
        <dropdown-option
          v-if="$login.can('accounts.update') && $login.can('subscriptions.create')"
          class="page-header-dropdown-item"
          @click.native="createSubscription"
          href="javascript:;"
        >
          <icon
            icon="subscriptions"
            class="mr-2"
          /> Create subscription
        </dropdown-option>
      </dropdown>
    </page-header>

    <tabs ref="tabs">
      <!-- Analytics tab -->
      <tab
        v-if="$login.canAnalytics()"
        name="Analytics"
      >
        <analytics
          :data="data"
          :channel-name="$login.can('analytics.channel') && $login.getChannel() ? $login.getChannelName() : 'Network'"
        />
      </tab>

      <!-- Activity tab -->
      <tab
        v-if="$login.can('accounts.audit')"
        name="Activity"
      >
        <activity
          :data="data"
          type="account"
        />
      </tab>

      <!-- Users tab -->
      <tab name="Users">
        <users :data="data" />
      </tab>

      <!-- Subscriptions tab -->
      <tab
        name="Subscriptions"
        v-if="$login.can('accounts.subscriptions.view')"
      >
        <subscriptions
          :account="data"
          @created-subscription="createdSubscription"
        />
      </tab>

      <!-- Account Details tab -->
      <tab name="Details">
        <div>
          <account-form
            v-if="canEdit"
            v-model="data"
          />

          <read-only
            v-else
            :account="data"
          />
        </div>
      </tab>
    </tabs>
  </div>
</template>

<script>
import Tabs from '@/components/Tabs'
import Tab from '@/components/Tab'
import {get} from '@/helpers'

import Analytics from './Analytics'
import Activity from '@/components/Activity'
import Users from './Users'
import AccountForm from './Form'
import Subscriptions from './Subscriptions'
import ReadOnly from './ReadOnly'
import {successNotification} from '@/notifications'

import Dropdown from '@/components/Dropdown/Dropdown'
import DropdownOption from '@/components/Dropdown/DropdownOption'

export default {
  components: {
    Dropdown,
    DropdownOption,
    Tabs,
    Tab,
    Analytics,
    Activity,
    Users,
    AccountForm,
    Subscriptions,
    ReadOnly,
  },

  data () {
    return {
      user: this.$login.getUser(),
      data: null,
      loading: false,
    }
  },

  metaInfo () {
    return {
      title: this.data && this.data.name ? this.data.name : 'View Account',
    }
  },

  computed: {
    disableTabs () {
      return [!this.$login.can('audit.accounts') ? 'Activity' : null]
    },

    canEdit () {
      return this.$login.can('accounts.update')
    },
  },

  created () {
    this.getUser(this.$route.params.accountId)
  },

  methods: {
   generateExcel (timeframe=this.$timeframe) {
      this.$http.post(`/reports/account/${this.data.id}?timeframe=${timeframe}&user_id=${this.user.id}`)
        .then((response) => {
          this.$notify(successNotification(`A report download link will be emailed to ${this.user.email} as soon as it has been generated, typically within 5 minutes`))
        })
    },

    getUser (id) {
      return get(`accounts/${id}`).then(this.setData)
    },

    setData ({data: {data}}) {
      if (!data.address) {
        data.address = {}
      }
      this.data = data
    },

    createdSubscription (subscription) {
      this.$notify(successNotification('Created subscription successfully'))
      this.data.subscriptions.push(subscription)
    },

    updated (response) {
      const msg = `Successfully updated ${response.data.data.name}`

      this.$notify(successNotification(msg))
    },

    addUser () {
      this.$router.replace({
        name: 'users.create',
        query: {
          onComplete: this.$route.path,
        },
      })
    },

    createSubscription () {
      this.$refs.tabs.activateTab('Subscriptions')
      this.$nextTick(() => {
        this.$modal.show('create-subscription')
      })
    },
  },
}
</script>
